// Module is disabled by default, to enable:
// localStorage.setItem("dev", "true");
import actionTypes from './actionTypes'
import actions from './actions'
import constants from './constants'
import reducer from './reducer'
import saga from './saga'

// Components

export default {
  actionTypes,
  actions,
  constants,
  reducer,
  saga,
  components: {}
}
